module.exports = __webpack_public_path__ + "static/flags/FO-61c22d1a943de168762a6ee1cbb44d05.gif";